module.exports = __webpack_public_path__ + "img/B6403_CyclewayVisuals_Location_01b_crop_03.35d82e2c.jpg";